<template>
  <b-container class="mb-3">
    <b-row>
      <b-col>
        <b-card no-body>
          <b-tabs ref="wizard" v-model="tab" fill pills card @activate-tab="setTitle">
            <div style="padding-top: 10px; padding-left: 10px; padding-right: 10px ">
              <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
                La sezione Digitalizzazione del Pregresso consente la digitalizzazione di regolamenti cartacei firmati prima del 01/01/2020.
              </b-alert>
            </div>
            <b-tab title="Lettura Codice Tessera">
              <b-form @submit="proceed">
                <b-form-row>
                  <b-form-group
                    label="Codice carta"
                    description="Oppure inserire il codice della carta fidelity manualmente."
                    class="col-md-12">
                    <b-form-input v-model="cardId" placeholder="Inserisci il codice" :state="cardIdIsValid"
                                  aria-describedby="cardIdFeedback"></b-form-input>
                    <b-form-invalid-feedback id="cardIdFeedback">
                      Il codice deve essere numerico e di 13 cifre
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-form-row>
                <b-form-row class="text-center">
                  <b-form-group
                    id="input-group-1"
                    label="Lettura codice a barre"
                    description="Posizionare il codice a barre di fronte alla fotocamera"
                    class="col-md-12">
                    <BarcodeScanner v-on:barcode-read="barcodeRead"/>
                  </b-form-group>
                </b-form-row>
              </b-form>
            </b-tab>
            <b-tab title="Anteprima" :disabled="tabsDisabled.preview">
              <b-row>
                <b-col class="mb-3" sm="4" v-for="(paperAgreement, index) in paperAgreements" :key="index">
                  <b-card :title="titleCardFrom(paperAgreement.demandType)" title-tag="h5" :bg-variant="backgroundVariantCard(paperAgreement.id)"
                          :border-variant="borderVariantCard(paperAgreement)">
                    <b-card-text>{{ paperAgreement.firstName }} {{ paperAgreement.lastName }}</b-card-text>
                    <b-card-text>Cod Negozio {{ paperAgreement.storeCode }}</b-card-text>
                    <b-card-text v-if="paperAgreement.digitalizedAt">Digitalizzato il
                      {{ formatDateTime(paperAgreement.digitalizedAt) }}
                    </b-card-text>
                    <b-card-text v-if="!paperAgreement.digitalizedAt">Da digitalizzare</b-card-text>
                    <b-button :disabled="paperAgreement.digitalizedAt !== undefined && paperAgreement.digitalizedAt !== null" variant="primary"
                              @click="selectPaperAgreement(paperAgreement.id)" id="select-button">Seleziona
                    </b-button>
                  </b-card>
                </b-col>

              </b-row>

            </b-tab>
            <b-tab id="agreement-tab" title="Regolamento" :disabled="tabsDisabled.agreement">
              <PaperAgreementDetail v-if="paperAgreementId != null" :paper-agreement-id="paperAgreementId"></PaperAgreementDetail>
            </b-tab>
            <b-tab title="Documento" :disabled="tabsDisabled.document">
              <div v-if="!tabsDisabled.document">
                <DocumentUpload v-model="uploadDocument"></DocumentUpload>
                <b-form-group label="Data di Firma" class="col-md-12">
                  <DatePicker id="signed-at" description="Data di firma" v-model="signedAt" :required="true" :not-after-today="true" />
                </b-form-group>
              </div>
            </b-tab>
          </b-tabs>
          <template #footer>
            <div class="text-right">
              <b-button ref="wizardProceed" variant="primary" @click="proceed"
                        :disabled="digitalizing || isInDigitalize || paperAgreementNotSelected">
                <b-spinner small :hidden="!digitalizing"></b-spinner>
                {{ proceeding }}
              </b-button>
            </div>
            <div style="float: right; padding-top: 10px">
              <p style="font-size: 11px">Powered by <img width="100px" src="../assets/CherryChainLogo.png" alt="CherryChain"></img></p>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import PaperAgreementsApi from '../api/PaperAgreementsApi'
import BarcodeScanner from '../components/digitalization/BarcodeScanner'
import PaperAgreementDetail from '@/components/digitalization/PaperAgreementDetail'
import moment from 'moment'
import demandsType from '../DemandsType'
import DocumentUpload from '@/components/digitalization/DocumentUpload'
import DatePicker from '@/components/DatePicker'
import eventBus from "@/EventBus";

const BARCODE = 0
const PREVIEW = 1
const AGREEMENT = 2
const DOCUMENT = 3

const PROCEDI = 'Procedi'
const CONFERMA = 'Conferma'

function initialState () {
  return {
    showAlert: false,
    cardId: '',
    tab: BARCODE,
    proceeding: PROCEDI,
    paperAgreements: [],
    paperAgreementId: null,
    uploadDocument: {},
    signedAt: null,
    digitalizing: false,
    tabsDisabled: {
      preview: true,
      agreement: true,
      document: true
    },
    backPicture: null,
    frontPicture: null
  }
}

export default {
  name: 'Digitalization',
  components: { PaperAgreementDetail, BarcodeScanner, DocumentUpload, DatePicker },
  provide () {
    return { parentValidator: this.$validator }
  },
  data: () => initialState(),
  mounted() {
    eventBus.$on("show-alert", () => this.showAlert = true)
  },
  methods: {
    momentNow () {
      return moment.now()
    },
    resetState () {
      let state = initialState()
      Object.assign(this.$data, state)
      this.$validator.reset()
    },
    titleCardFrom (demandType) {
      return demandsType.find(type => type.value === demandType).text
    },
    formatFileNames () {
      return ''
    },
    setTitle (nextTab, prevTab) {
      if (nextTab === AGREEMENT && prevTab === DOCUMENT) this.tabsDisabled.document = true
      this.tab = nextTab
      switch (this.tab) {
        case DOCUMENT:
          this.proceeding = CONFERMA
          break
        default:
          this.proceeding = PROCEDI
          break
      }
    },
    proceed (event) {
      if (event) event.preventDefault()

      this.$refs.wizardProceed.focus()
      switch (this.tab) {
        case BARCODE:
          this.tabsDisabled.preview = false
          this.loadPaperAgreements().then(() => {
            this.$nextTick().then(() => this.tab = PREVIEW)
          })
          break
        case PREVIEW:
          this.tabsDisabled.agreement = false
          this.$nextTick().then(() => this.tab = AGREEMENT)
          break
        case AGREEMENT:
          this.$validator.validateAll()
            .then(result => {
              if (result) {
                this.tabsDisabled.document = false
                this.$nextTick().then(() => this.tab = DOCUMENT)
                this.proceeding = CONFERMA
              }
            })
          break
        case DOCUMENT:
          this.$validator.validateAll()
            .then(result => {
              if (result) {
                this.digitalize()
              }
            })
          break
      }
    },
    makeToast (type = null, message) {
      this.$bvToast.toast(message, {
        title: 'Digitalizzazione',
        variant: type,
        toaster: 'b-toaster-top-center',
        solid: true
      })
    },
    borderVariantCard (paperAgreement) {
      return (paperAgreement.digitalizedAt ? 'success' : 'warning')
    },
    backgroundVariantCard (paperAgreementId) {
      return (paperAgreementId === this.paperAgreementId ? 'warning' : '')
    },
    digitalize () {
      if (this.paperAgreementId !== null) {
        this.digitalizing = true
        PaperAgreementsApi
          .digitalize(this.paperAgreementId, {
            frontPicture: this.uploadDocument.frontPicture,
            backPicture: this.uploadDocument.backPicture,
            dataEntryMode: 'DIGITALIZED_MORE',
            signedAt: this.signedAt,
            frontPdf: this.uploadDocument.frontPdf,
            backPdf: this.uploadDocument.backPdf
          })
          .then(() => {
            this.loadPaperAgreements()
            this.resetState()
            this.makeToast('success', 'Digitalizzazione avvenuta con successo')
          })
          .catch(() => this.makeToast('danger', 'Digitalizzazione fallita!!'))
          .finally(() => this.digitalizing = false)
      }
    },
    loadPaperAgreements () {
      return PaperAgreementsApi.getFor(this.cardId)
        .then(res => {
          this.paperAgreements = res
        })
    },
    barcodeRead (event) {
      this.cardId = event.barcode
      this.loadPaperAgreements()
    },
    selectPaperAgreement (paperAgreementId) {
      const paperAgreement = this.paperAgreements.filter(it => it.paperAgreementId === paperAgreement)
      this.paperAgreementId = paperAgreementId
    },
    formatDateTime (date) {
      return date
        ? moment.parseZone(date).format('DD/MM/YYYY HH:mm')
        : ''
    },
    stateValidation (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref)
      } else {
        return null
      }
    }
  },
  computed: {
    cardIdIsValid () {
      if (this.cardId) {
        return this.cardId.length === 13 && Number.isInteger(Number(this.cardId))
      }
      return null
    },
    isInDigitalize () {
      return this.tab === DOCUMENT && (this.frontPicture === null && this.backPicture === null && this.frontPdf === null && this.backPdf === null)
    },
    paperAgreementNotSelected () {
      return this.tab === PREVIEW && this.paperAgreementId === null
    }
  }
}
</script>
